// import { Text } from '@pancakeswap-libs/uikit'
import styled from 'styled-components'

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #280D5F;
  line-height: 20px;
  padding: 28px 24px;
  background: linear-gradient(103deg, #F2ECF2, #E8F2F6);
`
export const InputBox = styled.div`
  margin-bottom: 20px;
`
export const InputTitle = styled.div`
  font-size: 14px;
  color: #280D5F;
  margin-bottom: 10px;
`
export const WarnTip = styled.div`
  font-size: 13px;
  color: #FF7F00;
  line-height: 23px;
  padding: 24px;
  // background: #FFF6E8;
  // border: 1px solid #FFC323;
  // border-radius: 12px;
  // margin-bottom: 20px;
`
export const Wrapper = styled.div`
  position: relative;
`

export const CardContent = styled.div`
  background: #FAF9FA;
  border-top: 1px solid #E7E3EB;
  padding: 30px 24px;
`

export const AddressBox = styled.div`
  margin-bottom: 20px;
`
export const AddressTitle = styled.div`
  font-size: 14px;
  color: #18184E;
  margin-bottom: 10px;
`
export const AddressText = styled.div`
  font-size: 14px;
  color: #7A6EAA;
  flex: 1;
  margin-right: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const CopyIcon = styled.img<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`
export const LockBox = styled.div`
  background: #fff;
  margin-bottom: 20px;
  border: 1px solid #E7E3EB;
  padding: 20px;
  border-radius: 24px;
`
export const LockText = styled.div`
  font-size: 14px;
  color: #280D5F;
  font-weight: bold;
`
export const LockClickText = styled.div`
  font-size: 14px;
  color: #1EC7D3;
  font-weight: bold;
`
export const LockInputBox = styled.div`
  background: #EEEAF4;
  height: 46px;
  border-radius: 16px;
  border: 1px solid #D7CAEC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  position: relative;
`

export const Icon = styled.img<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`
export const TokenPopBox = styled.div`
  background: #fff;
  position: absolute;
  width: 70px;
  padding: 15px 0;
  border-radius: 12px;
  top: 50px;
  right: 0;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
`
export const TokenPopItem = styled.div`
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
  font-size: 15px;
  color: #280D5F;
  font-weight: bold;
  &.active{
    color: #1EC7D3;
  }
`

export const EarningCountdown = styled.div`
  padding: 20px;
  background: linear-gradient(180deg, #7645D8, #472B7D);
  border-radius: 16px;
  margin-top: 20px;
`
export const EarningText = styled.div`
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 22px;
  font-wight: bold;
`
export const CountdownBox = styled.div`
  background: linear-gradient(90deg, #3A1D75, #472B81);
  border-radius: 16px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  margin-bottom: 20px;
`
export const CountdownContent = styled.div`
  height: 46px;
  color: #280D5F;
  font-size: 14px;
  font-weight: bold;
  line-height: 46px;
  background: linear-gradient(90deg, #FECD0D 0.146484375%, #FFA849 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  span{
    font-size: 20px;
    margin-left: 3px;
  }
`
export const TabBox = styled.div`
  font-size: 13px;
  color: #7A6EAA;
  font-weight: bold;
  padding: 18px 20px;
  border-bottom: 1px solid #E7E3EB;
`

export const TabItem = styled.div`
  &.active{
    font-size: 15px;
    color: #311765;
  }
`
export const RecordBox = styled.div`
  padding: 15px;
`
export const RecordItem = styled.div`
  padding: 0 15px;
  border-radius: 10px;
  background: #FAF9FA;
`
export const CommonText = styled.div`
  font-size: 13px;
  color: #280D5F;
`

export const AirIcon = styled.img<{ width: string, height: string}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  display: block;
  top: -65px;
  position: absolute;
  right: -13px;
  z-index: 5;
`
export const AirIconBox = styled.div`
  position: relative; 
  width:100%;
  height: 30px;
  max-width: 436px;
  margin: 0 auto  25px;
`
